export default {
  DISPLAY_PREFERENCES: 'displayPreferences',
}
